{
  "list": {
    "attributes": {
      "friendlyName": "Nome",
      "type": "Tipo",
      "serialNumber": "Numero di serie",
      "firmwareVersion": "Versione software",
      "hardwareVersion": "Versione hardware",
      "state": "Stato",
      "createdAt": "Data di creazione",
      "connectivity": {
        "name": "Connettività",
        "connected": {
          "lessThan": "L’apparato si è connesso meno di {duration} fa.",
          "greaterThan": "L’apparato si è connesso più di {duration} fa."
        },
        "duration": {
          "seconds": "{count} secondi | {count} secondo | {count} secondi",
          "minutes": "{count} minuti | {count} minuto | {count} minuti",
          "hours": "{count} ore | {count} ora | {count} ore"
        }
      },
      "metastatus": {
        "name": "Metastato",
        "status": {
          "success": "Tutte le ultime operazioni di questo apparato si sono svolte correttamente.",
          "mixed": "Almeno una delle ultime operazioni di questo apparato è in errore.",
          "error": "Tutte le ultime operazioni di questo apparato sono in errore."
        }
      },
      "sector": "Rete",
      "actionInProgress": "Azioni in corso",
      "certificateExpirationRange": "Certificato"
    }
  },
  "stateValue": {
    "PREPROVISIONED": "Fornito preliminarmente",
    "REGISTERED": "Salvato"
  },
  "import": {
    "title": "Importa",
    "text": "Importa",
    "header": {
      "text": "Importa gli apparati forniti preliminarmente"
    },
    "clickToUpload": "Clicca per selezionare",
    "orDragAndDrop": "o trascina un file .ZIP",
    "action": {
      "report": "Analizza",
      "execution": "Importa"
    },
    "inProgress": {
      "report": "Analisi in corso…",
      "execution": "Importazione in corso…"
    },
    "results": {
      "report": {
        "total": "Nessun apparato rilevato | 1 apparato rilevato | {count} apparati rilevati",
        "succeed": {
          "exist": "Apparati convalidati da aggiornare:",
          "new": "Apparati convalidati da creare:"
        },
        "failed": "Apparati in errore:"
      },
      "execution": {
        "total": "Nessun apparato elaborato | 1 apparato elaborato | {count} apparati elaborati",
        "succeed": {
          "exist": "Apparati aggiornati:",
          "new": "Apparati creati:"
        },
        "failed": "Apparati in errore:"
      }
    },
    "validation": {
      "fileMandatory": "Il file deve essere uno .ZIP",
      "fileEmpty": "Il file .ZIP non deve essere vuoto"
    }
  },
  "form": {
    "description": {
      "title": "Descrizione",
      "idCard": {
        "title": "Carta d’identità",
        "attributes": {
          "name": "Nome",
          "type": "Tipo",
          "model": "Gamma",
          "serialNumber": "Numero di serie",
          "hardwareVersion": "Versione hardware",
          "manufacturer": "Produttore",
          "sector": "Rete"
        }
      },
      "state": {
        "title": "Stato",
        "attributes": {
          "state": "Stato",
          "firstConnection": "Prima connessione",
          "lastConnection": "Ultima connessione",
          "batteryStatus": "Stato della batteria",
          "lastChange": "Ultima modifica",
          "configurationApplicationDate": "Data di applicazione della configurazione",
          "lastRebootDate": "Data dell’ultimo riavvio",
          "firstCommissioningDate": "Data della prima messa in servizio",
          "certificateExpirationDate": "Data di scadenza del certificato",
          "firmwareVersion": "Versione del firmware",
          "latestFirmwareUpdate": "Ultimo aggiornamento del firmware",
          "lastCertificateUpdate": "Ultimo aggiornamento del certificato",
          "lastSynchronisation": "Ultima sincronizzazione dell’apparato:",
          "lastDisconnectionDate": "Data dell’ultima disconnessione"
        }
      },
      "connectivity": {
        "title": "Connettività",
        "communication": "Comunicazione",
        "simCard": "Scheda SIM",
        "attributes": {
          "antenna": "Antenna",
          "mobileNetwork": "Rete mobile",
          "gsmFrequencyBand": "Banda di frequenza GSM",
          "communicationProtocol": "Protocollo comunicazione",
          "accessPointName": "Nome del punto di accesso (APN)",
          "userName": "Nome utente"
        },
        "status": "Stato di connettività"
      },
      "geolocation": {
        "title": "Descrizione del sito",
        "attributes": {
          "address": "Indirizzo",
          "latlong": "Lat: {latitude} - Lon: {longitude}",
          "status": "Geolocalizzazione"
        }
      },
      "characteristics": {
        "title": "Caratteristiche"
      }
    },
    "configuration": {
      "title": "Configurazione",
      "information": {
        "configurationType": {
          "label": "Tipo di parametrizzazione",
          "SELF_SUPPORTING": "Indipendente",
          "GLOBAL_AND_SPECIFIC": "Globale + specifica"
        },
        "selfSupportingVersion": "Versione indipendente",
        "globalVersion": "Versione globale",
        "specificVersion": "Versione specifica",
        "configurationOrigin": "Origine della parametrizzazione",
        "lastUpdate": "Ultimo aggiornamento"
      },
      "operations": {
        "title": "Operazioni"
      },
      "upload": {
        "userInformation": {
          "title": "Caricamento della parametrizzazione",
          "description": "Questa parametrizzazione sarà disponibile solo per questo apparato."
        },
        "error": {
          "invalidFileType": "Il file deve avere un formato JSON o JWT.",
          "fileSize": "Il file di parametrizzazione deve essere inferiore a 750 MB.",
          "emptyFile": "Il file di parametrizzazione non deve essere vuoto.",
          "fileAlreadyExist": "Questo file di parametrizzazione esiste già per questo apparato."
        },
        "title": "Caricamento della parametrizzazione",
        "confirm": {
          "title": "Annullamento del caricamento della parametrizzazione",
          "message": "Annullare il caricamento della parametrizzazione?\nTutti i dati andranno persi."
        },
        "form": {
          "title": "Informazioni della parametrizzazione",
          "versionName": "Nome della versione",
          "version": "Versione",
          "type": "Tipo"
        },
        "buttonTooltip": "Carica una parametrizzazione",
        "success": "Il caricamento della parametrizzazione è andato a buon fine"
      },
      "update": {
        "title": "Aggiornamento della parametrizzazione",
        "warning": "Un’operazione dello stesso tipo è già stata programmata o è in esecuzione per l’apparecchio",
        "scheduling": {
          "title": "Programmazione",
          "label": "Programma l’aggiornamento",
          "placeholder": "Seleziona una data di aggiornamento"
        },
        "configurationSelection": {
          "title": "Parametrizzazione",
          "radio": {
            "specific": "Specifica",
            "globalAndSpecific": "Globale e specifica"
          },
          "label": "Seleziona una parametrizzazione nell’elenco sottostante",
          "placeholder": "Seleziona una parametrizzazione",
          "specific": "Parametrizzazione specifica",
          "global": "Parametrizzazione globale"
        },
        "instantSending": {
          "label": "Consegna istantanea",
          "tooltip": "Trasmissione dell’operazione all’apparato il prima possibile."
        },
        "cancel": {
          "confirm": {
            "title": "Annullamento dell’aggiornamento della configurazione",
            "message": "Vuoi davvero annullare l’aggiornamento della configurazione? Tutti i dati andranno persi."
          }
        }
      },
      "browse": {
        "selfSupporting": "Sfoglia le parametrizzazioni indipendenti",
        "specific": "Sfoglia le parametrizzazioni specifiche"
      },
      "list": {
        "title": {
          "selfSupporting": "Parametrizzazioni indipendenti",
          "specific": "Parametrizzazioni specifiche"
        },
        "search": {
          "placeholder": "Cerca per etichetta versione o versione"
        },
        "noConfiguration": "Nessuna parametrizzazione trovata",
        "columns": {
          "versionName": "Nome della versione",
          "version": "Versione",
          "uploadedDate": "Data di caricamento"
        },
        "periodPicker": {
          "placeholder": "Seleziona un periodo"
        }
      }
    },
    "dataviz": {
      "title": "Visualizzazione dei dati",
      "day": "Giorno",
      "week": "Settimana",
      "month": "Mese",
      "quarter": "Trimestre",
      "newChart": "Trascinare e rilasciare qui i dati per creare un nuovo grafico.",
      "noData": "Dati non presenti"
    },
    "firmware": {
      "title": "Firmware",
      "state": {
        "attributes": {
          "firmwareVersion": "Versione",
          "latestFirmwareUpdate": "Ultimo aggiornamento"
        }
      },
      "information": {
        "attributes": {
          "latestFirmwareUpdate": "Ultimo aggiornamento",
          "firmwareUpdateSource": "Origine",
          "firmwareUpdateSourceOption": {
            "mobileApp": "App mobile",
            "factory": "Fabbrica"
          }
        }
      },
      "updateFirmware": "Aggiornamento del firmware"
    },
    "logs": {
      "title": "Giornali",
      "lastOperationReportUpdateDate": {
        "label": "Ultima data di caricamento del report operativo"
      },
      "noLogsFound": "Nessun giornale trovato"
    },
    "additionalMetadata": {
      "title": "Metadati aggiuntivi",
      "options": {
        "title": "Opzioni",
        "processControl": "Automatismo",
        "pumpingStation": "Stazione di sollevamento",
        "webServer": "Server Web",
        "webMimicDiagram": "Sinottici Web",
        "ipBackup": "Emergenza IP ADSL / GSM",
        "iecSlave": "IEC60870-5-104 Slave",
        "externalControlLiftStation": "Controllo esterno della stazione di sollevamento",
        "pumpingOptimization": "Ottimizzazione del pompaggio",
        "dataPoints": "N. di informazioni: {value}",
        "ioModules": "Numero di moduli I/O: {value}",
        "comModules": "Numero di moduli COM: {value}",
        "calendars": "Numero di calendari: {value}",
        "schedules": "Numero di orari (Schedules): {value}",
        "objects": "Numero di oggetti: {value}",
        "allowedLocalPost": "Stazioni remote: {value}",
        "licenceExpirationDate": "Data di scadenza della licenza: {value}",
        "licenceId": "Numero di licenza: {value}"
      },
      "communicationModules": {
        "title": "Moduli di comunicazione"
      },
      "modules": {
        "location": "Luogo",
        "module": "Module"
      },
      "ioModules": {
        "title": "Moduli I/O"
      },
      "networkInterfaceCardExtensions": {
        "title": "Estensione/i della scheda di interfaccia di rete"
      },
      "ioCardExtensions": {
        "title": "Estensione/i della scheda IO"
      },
      "modemCardExtensions": {
        "title": "Estensione/i della scheda del modem"
      },
      "comments": {
        "title": "Commenti"
      }
    },
    "certificate": {
      "title": "Certificato",
      "information": {
        "title": "Certificato",
        "attributes": {
          "certificateExpirationDate": "Data di validità del certificato",
          "lastCertificateUpdate": "Ultimo aggiornamento del certificato",
          "origin": "Origine del certificato",
          "origins": {
            "mobileApplication": "Applicazione mobile",
            "lxConnect": "LX CONNECT"
          }
        }
      }
    }
  },
  "empty": "Non è stato trovato nessun apparato",
  "lifeCycleState": {
    "preprovisioned": "Fornito preliminarmente",
    "registered": "Salvato",
    "activated": "Attivato",
    "disabled": "Disattivato",
    "locked": "Bloccato"
  },
  "filters": {
    "searchByNameOrSerialNumber": "Cerca per nome o numero di serie",
    "compatibilityQuickFilters": {
      "allDevices": "Tutti gli apparati",
      "compatibleDevices": "Apparati compatibili",
      "incompatibleDevices": "Apparati incompatibili"
    },
    "deviceType": "Tipo",
    "selectionQuickFilters": {
      "allDevices": "Tutti gli apparati",
      "selectedDevices": "Apparati selezionati",
      "unselectedDevices": "Apparati deselezionati"
    },
    "lifecycleState": "Stato",
    "connectivity": {
      "label": "Connettività",
      "type": "Tipo di collegamento dell'apparato",
      "status": "Stato",
      "SHORT_LIVED": "Interrogazione",
      "GOOD": "Meno di 24 ore",
      "WARN": "Più di 24 ore",
      "ERROR": "Più di 72 ore",
      "empty": "Nessuno stato disponibile",
      "PERSISTENT": "Persistente",
      "ONLINE": "Connesso",
      "OFFLINE": "Disconnesso"
    },
    "ranges": {
      "label": "Intervallo"
    }
  },
  "fleet": {
    "cancelSelection": "Elimina selezione",
    "selectedDevices": "Nessun apparato selezionato | {count} apparato selezionato | {count} apparati selezionati",
    "addToFleet": "Aggiungi a una flotta",
    "removeFromFleet": "Rimuovere dalla flotta"
  },
  "deviceFound": "Nessun apparato trovato | {count} apparato trovato | {count} apparati trovati",
  "action": {
    "enable": "Attiva l’apparato",
    "disable": "Disattiva l’apparato",
    "confirm": {
      "title": "Disattivare l’apparato?",
      "description": "Disattivare questo apparato? Questa azione eviterà qualsiasi comunicazione con la piattaforma e saranno eliminate tutte le operazioni attualmente in esecuzione.",
      "disable": "Disattiva"
    },
    "button": {
      "enable": "Attiva",
      "disable": "Disattiva"
    },
    "delete": {
      "tooltip": "Elimina apparato",
      "confirm": {
        "title": "Eliminazione apparato",
        "message": "L'eliminazione di un apparato cancellerà definitivamente tutti i suoi dati, le sue operazioni e la sua telemisura."
      }
    }
  },
  "cartography": {
    "title": "Cartografia",
    "deviceMapTile": {
      "button": {
        "seeDevice": "Vedi l’apparato"
      }
    },
    "devicesMap": {
      "noDevices": "Nessun apparato da visualizzare"
    }
  },
  "globalConfiguration": {
    "automaticRenewalDelay": {
      "information": {
        "title": "Ritardo rinnovo automatico certificato",
        "body": "Definisce quanto tempo prima della scadenza il certificato dell'apparato verrà rinnovato automaticamente."
      },
      "label": "Ritardo rinnovo automatico certificato",
      "values": {
        "nDay": "1 giorno | {n} giorni",
        "nMonth": "1 mese | {n} mesi",
        "nYear": "1 anno | {n} anni"
      },
      "custom": {
        "label": "Personalizzato",
        "unit": "giorno | giorni"
      },
      "error": {
        "required": "Il ritardo di rinnovo automatico è obbligatorio",
        "minMax": "Il ritardo di rinnovo automatico deve essere compreso tra {min} e {max}"
      }
    },
    "pollingFrequency": {
      "information": {
        "title": "Frequenza interrogazione",
        "body": "Definisce l'intervallo di tempo tra due comunicazioni dall'apparato alla piattaforma."
      },
      "label": "Frequenza interrogazione",
      "values": {
        "nMinute": "1 minuto | {n} minuti",
        "nHour": "1 ora | {n} ore"
      },
      "custom": {
        "label": "Personalizzato",
        "unit": "minuto | minuti"
      },
      "error": {
        "required": "La frequenza di interrogazione è obbligatoria",
        "minMax": "La frequenza di interrogazione deve essere compresa tra {min} e {max}"
      }
    }
  }
}
